module.exports = __webpack_public_path__ + "img/max-file-configure--csv.fe7a7d13.svg";